export default "__VITE_ASSET__43145a25__"